export default "__VITE_ASSET__DcCwdQed__"